import type { UploadedFile } from "../schema/UploadedFile.js";

export function getUploadedFileExtension(file: UploadedFile): string {
	return file.path.split(".").filter(Boolean).slice(1).pop() ?? file.type;
}
